module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_case03-f7c86d6dc93551f47f24eb041bd8030e.svg";